import { TextField, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';

const UserDropdown = ({ value, onChange, users }) => {
	const userOptions = [
		{ label: 'All Users', value: 'all' },
		...(users || []).map((user) => ({
			label: user.full_name,
			value: user.id.toString(),
		})),
	];

	// Convert empty string from URL to 'all' for UI display
	const displayValue = value === '' ? 'all' : value;

	const handleChange = (e) => {
		// Convert 'all' back to empty string for backend
		const newValue = e.target.value === 'all' ? '' : e.target.value;
		onChange({ target: { value: newValue } });
	};

	return (
		<TextField
			data-testid='user-dropdown'
			select
			value={displayValue}
			onChange={handleChange}
			size='small'
			SelectProps={{
				renderValue: (selectedValue) => {
					const option = userOptions.find((opt) => opt.value === selectedValue);
					return option?.label || 'All Users';
				},
			}}
			sx={{
				width: '200px',
			}}
		>
			{userOptions.map((option) => (
				<MenuItem key={option.value} value={option.value}>
					{option.label}
				</MenuItem>
			))}
		</TextField>
	);
};

UserDropdown.propTypes = {
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	users: PropTypes.array.isRequired,
};

export default UserDropdown;
